import { FC } from 'react';

import Heading from 'quarks/Heading';
import Text from 'quarks/Text';

import type { ContentfulInPageFeatures } from 'graphqlTypes';

interface InPageFeaturesProps extends ContentfulInPageFeatures {
  backgroundIsDark?: boolean;
}

const InPageFeaturesHeading: FC<InPageFeaturesProps> = ({ backgroundIsDark, title, description }) => (
  <div className="mb-14 max-w-[1320px] ml-auto mr-auto">
    {(title || description) && (
      <div className="flex flex-col gap-[24px] text-center max-w-[770px] mx-[auto] my-[0] [@media(max-width:991px)]:mb-[30px]">
        {title && (
          <Heading as="h2" textStyle="h2" textAlign="center" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
            {title}
          </Heading>
        )}
        {description?.description && (
          <Text as="p" textColor={backgroundIsDark ? 'common-white' : 'gray-900'}>
            {description.description}
          </Text>
        )}
      </div>
    )}
  </div>
);

export default InPageFeaturesHeading;
